<div class="main-container block w-full h-full relative overflow-y-hidden">

  <div class="main-body h-full">

    <mat-drawer-container class="example-container h-full w-full">

      <mat-drawer class="vertical-gradiant side-nav" id="side-nav" [mode]="mode" [opened]="openSidenav" #sidenav>
        <app-side-bar></app-side-bar>
      </mat-drawer>

      <mat-drawer-content (scroll)="onWindowScroll($event)">
        <div class="header horizontal-gradiant bg-shadow" id="header">
          <app-header (sideNavToggle)="sidenav.toggle()" [showToggle]="showToggle"></app-header>
          <p-toast></p-toast>
        </div>
        <div class="main-content m-auto flex-column flex border-none">

          <router-outlet></router-outlet>

        </div>
        <app-footer></app-footer>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>

</div>

